<form clrForm [formGroup]="uploadFile" (ngSubmit)="submit()">
  <div *ngIf="!success" class="form-group">

    <app-file-upload formControlName="file" [progress]="progress"></app-file-upload>

    <clr-input-container>
        <label>Beschreibung:</label>
        <input clrInput formControlName="description" placeholder="Dateibeschreibung">
    </clr-input-container>

    <clr-select-container>
      <label>Dateityp:</label>
      <select clrSelect  formControlName="doctype">
        <option value="10">Anfrage</option>
        <option value="30">Angebot</option>
        <option value="20">Auftrag</option>
        <option value="6">Auftragsbestätigung</option>
        <option value="8">Dokumentation (Kunde)</option>
        <option value="80">Dokumentation (Lieferant)</option>
        <option value="40">Job</option>
        <option value="99">Kundenanfrage</option>
        <option value="98">Kundenbestellung</option>
        <option value="5">Lieferschein (an Kunde)</option>
        <option value="55">Lieferschein (von Lieferant)</option>
        <option value="71">Material (Datenblatt)</option>
        <option value="61">Mitteilung (Kunde)</option>
        <option value="60">Mitteilung (Lieferant)</option>
        <option value="70">Norm</option>
        <option value="9">NDA</option>
        <option value="3">Rechnung</option>
        <option value="2">Stückliste</option>
        <option value="4">Transportschein</option>
        <option value="1">Zeichnung</option>
        <option value="7">Sonstiges</option>
      </select>
    </clr-select-container>
  </div>
  <br />

  <div class="btn-group btn-primary btn-sm">
    <button *ngIf="!success" class="btn btn-primary">Hochladen</button>
    <button *ngIf="success" class="btn btn-success" (click)="closeModal()">Fertig!</button>
    <button *ngIf="!success" class="btn btn-outline-info" (click)="closeModal()">Abbrechen</button>
  </div>

</form>
